import type { DomainMapper } from '../types';

const base = {
  countryCode: 'gb',
  currency: 'GBP',
  dataAreaId: 'uk35',
  environment: 'production',
  flagUrl: '/flags/GB-UKM.svg',
  languagePrimary: true,
  locale: 'en-GB',
  logoUrl: 'kahrs-logo',
  noRobots: false,
  sitemapUrl: 'https://ecom-api.kahrs.com/storage/sitemaps/sitemap-uk.xml',
  storyblokBasePath: 'uk',
  algoliaIndex: 'b2b-uk-en-GB-products',
  algoliaIndexAutocomplete: 'b2b-uk-en-GB-products_query_suggestions',
  algoliaIndexPages: 'content_',
  applicationId: 1163,
  subFolder: true,
  googleSiteVerification: 'tHG4C4vnMgMxfElDcGevBx5-SKSflV4V5W_Rn6Ao8rM',
  b2b: {
    enabled: true,
    purchaseEnabled: true,
    storyblokBasePath: 'b2b',
    applicationId: 1163,
    algoliaIndex: 'b2b-uk-en-GB-products',
    algoliaIndexAutocomplete: 'b2b-uk-en-GB-products_query_suggestions',
    displayIncVat: false,
    default: false,
    productBasePath: 'b2b/product',
    sitemapUrl: 'https://ecom-api.kahrs.com/storage/sitemaps/sitemap-uk.xml',
  },
  b2c: {
    enabled: true,
    purchaseEnabled: true,
    storyblokBasePath: '',
    applicationId: 1164,
    algoliaIndex: 'b2c-uk-en-GB-products',
    algoliaIndexAutocomplete: 'b2c-uk-en-GB-products_query_suggestions',
    displayIncVat: true,
    default: true,
    productBasePath: 'product',
    features: {
      enableNorceCheckoutAddressUpdates: true,
    },
    sitemapUrl: 'https://ecom-api.kahrs.com/storage/sitemaps/sitemap-uk-b2c.xml',
  },
  features: {
    fastOrder: true,
    backorders: false,
    cartSettings: true,
    sampleInventory: true,
    sampleRequestNav: true,
  },
};

const gb: DomainMapper[] = ['new.kahrs.com', 'www.kahrs.com'].map((domain) => ({
  ...base,
  domain,
  legacyDomain: domain === 'new.kahrs.com',
  url: `https://${domain}/${base.storyblokBasePath}`,
} as DomainMapper));

export default gb;
